var $44ad94f7205cf593$exports = {};
$44ad94f7205cf593$exports = {
    "dismiss": `L\xf5peta`
};


export {$44ad94f7205cf593$exports as default};
//# sourceMappingURL=et-EE.module.js.map
